import React from 'react';
import { LinkButton } from '@cian/ui-kit';

import { IconDocument24 } from '../../Icons';
import { ListingItemType } from '../../../constants';
import {
  EType,
  IArticlesMainAttributesSchema,
} from '../../../repositories/journal/entities/journal/ArticlesMainAttributesSchema';
import { Headnote, IHeadnote } from '../components/Headnote';
import { Title } from '../components/Title';
import { Description } from '../components/Description';
import * as s from './DocumentCardListingItem.css';

interface IDocumentCardListingItem extends IHeadnote {
  url: string;
  children?: React.ReactNode;
  title?: IArticlesMainAttributesSchema['title'];
  subtitle?: string;
  documentUrl?: string;
  onArticleClick?(e: React.MouseEvent): void;
  onButtonClick?(e: React.MouseEvent, documentUrl: string): void;
}

/**
 * Элемент списка документов в виде карточки
 */
export const DocumentCardListingItem = ({
  title,
  url,
  subtitle,
  rubric,
  children,
  noIndex,
  documentUrl,
  onRubricButtonClick,
  onArticleClick,
  onButtonClick,
}: IDocumentCardListingItem) => {
  return (
    <article itemScope itemType={ListingItemType[EType.Articles]}>
      <div className={s['content-wrapper']} itemProp="articleBody">
        <Headnote
          beforeAll={
            <div className={s['icon-wrapper']}>
              <IconDocument24 color={'icon-primary-default'} />
            </div>
          }
          rubric={rubric}
          noIndex={noIndex}
          onRubricButtonClick={onRubricButtonClick}
        />

        <Title url={url} noIndex={noIndex} onClick={onArticleClick}>
          {title}
        </Title>

        <Description>{subtitle}</Description>

        {children}

        {Boolean(documentUrl) && (
          <LinkButton
            href={documentUrl}
            target={'_blank'}
            theme={'fill_secondary'}
            fullWidth
            onClick={e => onButtonClick && onButtonClick(e, documentUrl || '')}
          >
            Скачать
          </LinkButton>
        )}
      </div>
    </article>
  );
};
